import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { GlobalProvider } from "./context/GlobalProvider";

document.addEventListener("DOMContentLoaded", () => {
    const claimInsertElement = document.getElementById('claim-form-app');
    if (claimInsertElement) {
        ReactDOM.render(
            <GlobalProvider>
                <App />
            </GlobalProvider>,
            claimInsertElement
        );
    }
});

if (module.hot) {
    module.hot.accept();
}
